import isEmpty from 'lodash/isEmpty'
import 'array-flat-polyfill'
import moment from 'moment'

import removeEmptyFields from 'app/utils/removeEmptyFields'

const valueSerializer = (values) => {
    return {
        includeFilters: [`*${values}*`],
    }
}

const exactValue = (values) => {
    return {
        includeFilters: [values],
    }
}

const arraySerializer = (values) => {
    return {
        includeFilters: values,
    }
}

const range = ([
    from,
    to,
]) => {
    return {
        includeFilters: {
            from,
            to,
        },
    }
}

const dateRange = ({
    from,
    to,
}) => {
    return {
        includeFilters: {
            from,
            to,
        },
    }
}

const dayRange = ([
    from,
    to,
]) => {
    const toTimestampSec = moment().add(to, 'd').unix()
    const fromTimestampSec = moment().add(from, 'd').unix()

    return {
        includeFilters: {
            from: fromTimestampSec,
            to: toTimestampSec,
        },
    }
}

const booleanSwitch = (value) => {
    return {
        filters: value,
    }
}

const typeSerializers = {
    value: valueSerializer,
    exactValue,
    range,
    array: arraySerializer,
    dayRange,
    'date-range': dateRange,
    'integer-range': dateRange,
    'boolean-switch': booleanSwitch,
}

function generateFilters(filter, typeMapping = {}) {
    const filterCleanedUp = removeEmptyFields(filter)

    if (isEmpty(filterCleanedUp)) {
        return undefined
    }

    return Object.entries(filterCleanedUp).reduce((res, [
        key,
        value,
    ]) => {
        const fieldType = typeMapping[key] || 'array'

        const filterValue = typeSerializers?.[fieldType](value) || {}

        return removeEmptyFields({
            ...res,
            rangeFilters: removeEmptyFields({
                ...res.rangeFilters,
                [filterValue.rangeFilters ? key : undefined]: filterValue.rangeFilters,
            }),
            includeFilters: removeEmptyFields({
                ...res.includeFilters,
                [filterValue.includeFilters ? key : undefined]: filterValue.includeFilters,
            }),
            filters: removeEmptyFields({
                ...res.filters,
                [filterValue.filters ? key : undefined]: filterValue.filters,
            }),
        })
    }, [])
}

export default generateFilters
